<template>
  <section class="content">
    <div>
      <b-alert variant="danger"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{messageAlert}}
    </b-alert>
    </div>
    <div class="row center-block" v-if="exibirGrafico">
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">Desempenho</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
              <div class="row">
                <div class="col-sm-6">
                  <div id="example1_length" class="dataTables_length">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <td><strong>Data</strong></td>
                        <td><strong>Num Setups</strong></td>
                        <td><strong>Total Produzido</strong></td>
                        <td><strong>Tempo Ocioso (h)</strong></td>
                        <td><strong>Tempo Produzindo (h)</strong></td>
                        <td><strong>Tempo Setup (h)</strong></td>
                        <td><strong>Turno (h)</strong></td>
                        <td><strong>Tempo Médio Setup (h)</strong></td>
                        <td><strong>Prod. Caixa/Top</strong></td>
                        <td><strong>Prod. Caixa/T.D</strong></td>
                        <td><strong>Prod. Caixa/Setup</strong></td>
                        <td><strong>% Operando</strong></td>
                        <td><strong>% Setup</strong></td>
                        <td><strong>% Tempo Ocioso</strong></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in relatorios.tabeladesempenho" :key="index">
                        <td>{{index}}</td>
                        <td>{{data.qtdAcionamentosFuncao}}</td>
                        <td>{{data.total}}</td>
                        <td>{{data.horasOciosas}}</td>
                        <td>{{data.horasoperando}}</td>
                        <td>{{data.horasFuncao}}</td>
                        <td>{{data.tempoutil}}</td>
                        <td>{{data.tempoMedioSetup}}</td>
                        <td>{{data.prodCaixaTop}}</td>
                        <td>{{data.prodCaixaTurno}}</td>
                        <td>{{data.prodCaixaSetup}}</td>
                        <td>{{data.percentualOperando}}</td>
                        <td>{{data.percentualFuncao}}</td>
                        <td>{{data.percentualDisponivel}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
            <div class="box-footer">
            <div class="col-sm-2" v>
              <button type="button" v-on:click="onexport" class="btn btn-success"><i class="fa ion-arrow-down-c"></i> Exportar para Excel</button>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row center-block">
      <div class="col-md-12" >
        <div class="box">
          <div class="box-header col-md-12">
            <h3>Requisitos de pesquisa</h3>
            <div class="form-group col-sm-12">
              <label for="dataInicioBusca" class="col-sm-2 control-label">Data Inicial</label>
              <div class="col-sm-4"> 
                <datepicker placeholder="Selecione a data inicial" v-model="dataInicioBusca" id="dataInicioBusca" :language="ptBR"></datepicker>
              </div>
              <label for="dataFimBusca" class="col-sm-2 control-label">Data Final</label>
              <div class="col-sm-4">
                <datepicker placeholder="Selecione a data final" v-model="dataFimBusca" id="dataFimBusca" :language="ptBR"></datepicker>
              </div>
            </div>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="form-group col-sm-4" >
              <label for="maquinas" class="col-sm-2 control-label">Máquina</label>
              <select id="maquinas" class="form-control col-sm-4" v-model="pesquisa.idcontrolador">
                <option value="0">Selecione a Máquina</option>
                <option :value="monitor.idcontrolador" v-for="monitor in monitores" :key="monitor.id">{{monitor.nomemaquina}}</option>
              </select>
            </div>
            <div class="form-group col-sm-4" >
              <label for="turnos" class="col-sm-2 control-label">Turno</label>
              <select id="turnos" class="form-control col-sm-4" v-model="pesquisa.idTurnoSelecionado">
                <option value="0">Selecione o Turno</option>
                <option :value="turno.id" v-for="turno in turnos" :key="turno.id">{{turno.nometurno}}</option>
                <option value="999999">Todos os turnos</option>
                <option value="242424">24 horas</option>
              </select>
            </div>
          </div>
          <div class="box-footer">
            <div class="col-sm-2" v>
              <button type="button" v-on:click="efetuarPesquisa()" class="btn btn-primary" v-if="pesquisa.isDadosDisponiveis || pesquisa.isDadosOperando || pesquisa.isDadosFuncao || pesquisa.isDadosOutros">
                Efetuar Pesquisa
              </button>
              <button type="button" class="btn btn-primary"  disabled v-else>
                Efetuar Pesquisa
              </button>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
    </div>  
  </section>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'
import VAChart from '../VAChart'
import XLSX from 'xlsx'
// import swal from 'sweetalert2'

export default {
  name: 'RelatoriosProducaoPedidosTempo',
  components: {
    VueTimepicker,
    Datepicker,
    'va-chart': VAChart
  },
  mounted() {
    if (window.localStorage.getItem('token')) {
      this.$store.dispatch('listMonitores')
      this.$store.dispatch('listTurnos')
    } else {
      this.showDismissibleAlert = true
      this.messageAlert = 'Favor efetuar o login para visualizar os dados'
    }
  },
  computed: {
    monitores () {
      return this.$store.state.Monitores.all
    },
    turnos () {
      return this.$store.state.Turnos.all
    },
    relatorios () {
      return this.$store.state.Relatorios
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
  },
  data () {
    return {
      ptBR: ptBR,
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        idTurnoSelecionado: 0,
        idcontrolador: 0,
        isDadosOperando: true,
        isDadosFuncao: false,
        isDadosDisponiveis: false,
        isDadosOutros: false
      },
      desempenho: {
        Data: '',
        NumSetups: 0,
        TotalProduzido: 0,
        TempoOcioso: '00:00',
        TempoProduzindo: '00:00',
        TempoSetup: '00:00',
        Turno: '00:00',
        TempoMédioSetup: '00:00',
        ProdCaixaTop: 0,
        ProdCaixaTD: 0,
        ProdCaixaSetup: 0,
        PercOperando: 0.0,
        PercSetup: 0.0,
        PercTempoOcioso: 0.0
      },
      desempenhos: {},
      exibirGrafico: false,
      errors: []
    }
  },
  methods: {
    onexport () {
      // only array possible
      var animalWS = XLSX.utils.json_to_sheet(this.relatorios.desempenhos)
      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, animalWS, 'Desempenho') // sheetAName is name of Worksheet
      // export Excel file
      XLSX.writeFile(wb, this.RetornaDataHoraAtual() + '.xlsx') // name of the file is 'book.xlsx'
    },
    RetornaDataHoraAtual: function() {
      var dNow = new Date()
      var localdate = dNow.getDate() + '-' + (dNow.getMonth() + 1) + '-' + dNow.getFullYear() + ' ' + dNow.getHours() + dNow.getMinutes() + dNow.getSeconds()
      return localdate
    },
    track () {
      this.$ga.page('/RelatoriosProducaoPedidosTempo')
    },
    gerarTabelaDesempenho: function() {
      // criar
    },
    efetuarPesquisa: function() {
      this.exibirGrafico = false
      if (!window.localStorage.getItem('token')) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Favor efetuar o login para buscar o relatório'
      } else if ((this.dataInicioBusca === '') || (this.dataFimBusca === '')) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Não pode ter data vazia'
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Data final não pode ser anterior à data inicial'
      } else if (this.pesquisa.idcontrolador === 0) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Favor selecionar uma Máquina para pesquisa'
      } else if (this.pesquisa.idTurnoSelecionado === 0) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Favor selecionar um turno para pesquisa'
      } else {
        this.showDismissibleAlert = false
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10)
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10)
        this.$store.dispatch('createRelatorioProducaoPedidosTempo', this.pesquisa)
        .then(response => {
          this.exibirGrafico = true
        })
        .catch(e => {
          this.errors.push(e)
        })
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// RelatoriosProducaoPedidosTempo.vue?6fea13ed